import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { PedidoAnexo } from '../models/pedido-anexo';
import { PedidoRecebimento } from '../models/pedido-recebimento';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class PedidoRecebimentoService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarRecebimentos() {
    return this.http.get<PedidoRecebimento[]>(globals.apiUrl + '/api/PedidoRecebimento/Lista');
  }

  consultarRecebimentosComPaginacao(idCupom, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('idCupom', idCupom);
    
    return this.http.get<any>(globals.apiUrl + '/api/PedidoRecebimento/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoRecebimento/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(recebimento) {
    return this.http.post(globals.apiUrl + '/api/PedidoRecebimento/Salvar', recebimento);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/PedidoRecebimento/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarTotalRecebido(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/PedidoRecebimento/BuscarTotalRecebido',
      { params: new HttpParams().set('idCupom', idCupom) });
  }
}
